let publicData = {};
export function setPublicData(data){
    publicData=data;
}
export function getPublicData(){
    return publicData;
}